import React, { useEffect } from "react";
import { Logo } from "../components/site/Logo";

// Placeholder legal pages: kept noindex until finalized (per SEO spec).
export const LegalPage = ({ title, children }) => {
  useEffect(() => {
    const prev = document.querySelector('meta[name="robots"]')?.getAttribute("content");
    let meta = document.querySelector('meta[name="robots"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "robots");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", "noindex, nofollow");
    document.title = `${title} | Home Pro Connect`;
    return () => { if (meta && prev) meta.setAttribute("content", prev); };
  }, [title]);

  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-[rgba(19,57,85,0.08)]">
        <div className="max-w-3xl mx-auto px-6 py-5 flex items-center justify-between">
          <Logo />
          <a href="/" className="text-sm font-semibold text-[#133955] hover:underline">← Back to site</a>
        </div>
      </header>
      <main id="main-content" className="max-w-3xl mx-auto px-6 py-16">
        <h1 className="font-display text-4xl md:text-5xl font-extrabold tracking-tighter text-[#133955] mb-8">{title}</h1>
        <div className="space-y-5 text-[#173042]/85 leading-relaxed text-[17px]">{children}</div>
        <p className="mt-12 text-sm text-[#173042]/50">
          This page is a placeholder and will be finalized before launch.
        </p>
      </main>
      <footer className="border-t border-[rgba(19,57,85,0.08)]">
        <div className="max-w-3xl mx-auto px-6 py-8 text-sm text-[#173042]/60">
          © {new Date().getFullYear()} Home Pro Connect — a homeowner-to-contractor connection and referral service.
        </div>
      </footer>
    </div>
  );
};

export function Privacy() {
  return (
    <LegalPage title="Privacy Policy">
      <p>Home Pro Connect respects your privacy. The information you submit through our project request form is used to review your request and to communicate with you about a potential contractor connection.</p>
      <p>We may share your project details with an independent contractor whose services and coverage area may align with your project so they can contact you. We do not sell your personal information.</p>
      <p>You may request that we update or delete your information at any time by contacting us at business@homeproconnectsc.com. A finalized Privacy Policy will be published here before launch.</p>
    </LegalPage>
  );
}

export function Terms() {
  return (
    <LegalPage title="Terms & Disclosures">
      <p>Home Pro Connect is a homeowner-to-contractor connection and referral service. We help introduce homeowners to independent contractors whose services and coverage area may align with a project.</p>
      <p>Home Pro Connect does not perform, supervise, warrant, or guarantee any construction work. Independent contractors provide their own estimates, agreements, schedules, warranties, credentials, and project terms directly to the homeowner.</p>
      <p>By submitting a project request, you agree that Home Pro Connect and a contractor connected to your request may contact you by phone, email, or text regarding your project. Finalized Terms & Disclosures will be published here before launch.</p>
    </LegalPage>
  );
}
